import { render, staticRenderFns } from "./eventsFeed.vue?vue&type=template&id=0713673e"
import script from "./eventsFeed.vue?vue&type=script&lang=js"
export * from "./eventsFeed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports